import { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import { Card, Row, Col } from "react-bootstrap";
import axios from 'axios';
import portadacirp from "../assets/video/portada.png";
import logohorcirp from "../assets/img/lodohorcirp.jpg";
import { FaUsers, FaHandshake } from "react-icons/fa";

const url = "https://api.mrcirp.com/public/leads";
const videoApiUrl = "https://api.mrcirp.com/public/videos";

const Iniciouser = () => {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState({});
  const [videoEnded, setVideoEnded] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [stats, setStats] = useState({
    leads: 0,
    referidos: 12,
    ganancias: 850,
    invitaciones: 24,
    efectivas: 15
  });

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem('loginUser');
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);
  
  useEffect(() => {
    if (users.id) {
      peticionGet();
      fetchVideoData();
      setStats(prev => ({...prev, leads: data.length}));
    }
  }, [users, data.length]);

  const peticionGet = async () => {
    try {
      const response = await axios.get(`${url}/${users.id}`);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchVideoData = async () => {
    try {
      const response = await axios.get(videoApiUrl);
      // Asumimos que la API devuelve un array y tomamos el primer elemento
      const video = response.data[0];
      setVideoUrl(video.urlvideo);
    } catch (error) {
      console.error("Error fetching video data:", error);
    }
  };

  const handleVideoEnded = () => {
    setVideoEnded(true);
  };

  const getVimeoEmbedUrl = (url) => {
    if (!url) return null;
    
    try {
      // Manejar URLs con hash/token privado: vimeo.com/VIDEO_ID/HASH?params
      // Ejemplo: https://vimeo.com/1144165371/05113655ba?fl=pl&fe=sh
      const hashMatch = url.match(/vimeo\.com\/(\d+)\/([a-zA-Z0-9]+)/);
      if (hashMatch && hashMatch[1] && hashMatch[2]) {
        const videoId = hashMatch[1];
        const hash = hashMatch[2];
        // Para videos privados, el hash debe pasarse como parámetro 'h'
        return `https://player.vimeo.com/video/${videoId}?h=${hash}&autoplay=1`;
      }
      
      // Usar expresión regular más robusta para extraer el ID del video de cualquier formato de URL de Vimeo
      const vimeoRegex = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
      const match = url.match(vimeoRegex);
      
      if (match && match[3]) {
        return `https://player.vimeo.com/video/${match[3]}?autoplay=1`;
      }
      
      // Fallback: intentar extraer el ID de forma simple
      const simpleMatch = url.match(/vimeo\.com\/(\d+)/);
      if (simpleMatch && simpleMatch[1]) {
        return `https://player.vimeo.com/video/${simpleMatch[1]}?autoplay=1`;
      }
    } catch (error) {
      console.error('Error parsing Vimeo URL:', error);
    }
    
    return null;
  };

  const getYoutubeEmbedUrl = (url) => {
    if (!url) return null;
    
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = (match && match[2].length === 11) ? match[2] : null;
    return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0` : null;
  };

  const detectVideoType = (url) => {
    if (!url) return null;
    
    // Detectar YouTube (diferentes formatos)
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      return 'youtube';
    }
    
    // Detectar Vimeo (diferentes formatos)
    if (url.includes('vimeo.com')) {
      return 'vimeo';
    }
    
    // Detectar MP4 directo
    if (url.endsWith('.mp4') || url.includes('.mp4') || url.includes('video/mp4')) {
      return 'mp4';
    }
    
    return null;
  };

  const renderVideoPlayer = () => {
    if (!videoUrl) return <div>Cargando video...</div>;
    
    const videoType = detectVideoType(videoUrl);
    
    switch (videoType) {
      case 'youtube':
        const youtubeEmbedUrl = getYoutubeEmbedUrl(videoUrl);
        if (!youtubeEmbedUrl) {
          return <div>URL de YouTube no válida</div>;
        }
        return (
          <iframe
            width="100%"
            height="400"
            src={youtubeEmbedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Video KATANA"
          ></iframe>
        );
        
      case 'vimeo':
        const vimeoEmbedUrl = getVimeoEmbedUrl(videoUrl);
        if (!vimeoEmbedUrl) {
          return <div>URL de Vimeo no válida</div>;
        }
        return (
          <iframe
            src={vimeoEmbedUrl}
            width="100%"
            height="400"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="Video KATANA"
          ></iframe>
        );
        
      case 'mp4':
        return (
          <video
            width="100%"
            controls
            autoPlay
            poster={portadacirp}
            onEnded={handleVideoEnded}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        );
        
      default:
        return <div>Formato de video no soportado</div>;
    }
  };

  const efectividad = stats.invitaciones > 0 
    ? (stats.efectivas / stats.invitaciones) * 100 
    : 0;

  return (
    <div>
      <Sidebar>
        <div className="container-fluid mt-4 mb-5">
          <Row className="mb-4">
            <Col>
              <h2>KATANA ECOSISTEMA</h2>
              <p className="text-muted">Un ecosistema de Plataforma IA, Mentorias de alto nivel y Certificaciones internacionales.</p>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col lg={8}>
              <Card className="shadow-sm">
                <Card.Body className="p-0">
                  {!videoEnded ? (
                    renderVideoPlayer()
                  ) : (
                    <img src={logohorcirp} alt="Logo KATANA" width="100%" />
                  )}
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4}>
              <Row>
                <Col md={6} lg={12} className="mb-3">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 className="text-muted mb-2">Leads Captados</h6>
                          <h3>{stats.leads}</h3>
                        </div>
                        <div className="bg-info bg-opacity-10 p-3 rounded">
                          <FaHandshake size={24} className="text-info" />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                
                <Col md={6} lg={12} className="mb-3">
                  <Card className="h-100 shadow-sm">
                    <Card.Body>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 className="text-muted mb-2">Clientes Referidos</h6>
                          <h3>{stats.referidos}</h3>
                          <small className="text-muted">{stats.efectivas} efectivos</small>
                        </div>
                        <div className="bg-primary bg-opacity-10 p-3 rounded">
                          <FaUsers size={24} className="text-primary" />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Sidebar>
      
      <Footer />
    </div>
  );
};

const Footer = () => (
  <footer style={footerStyle}>
    <p>Copyright© 2024 - Benjamin Romero Corporación S.A. SJO Costa Rica - Todos los derechos reservados Ley 6683 Privacy Policy</p>
  </footer>
);

const footerStyle = {
  textAlign: 'center',
  padding: '7px',
  position: 'fixed',
  left: '0',
  bottom: '0',
  width: '100%',
  backgroundColor: '#f1f1f1',
  color: '#000',
};

export default Iniciouser;